import { State } from "@store/network/types";
import { ResourceStores, UsedResources } from "@store/network/ResourceStoresDefinitions";
import { UNTYPED_TYPE } from "@store/network/actions";

export function getResourcesStore<R extends keyof UsedResources | typeof UNTYPED_TYPE>(
  state: State,
  type: R): ResourceStores[R] {
  return state.resources[type];
}
